<template>
  <div class="horse-list">
		<table class="item-table">
			<thead>
				<tr class="item-headers">
					<th>
						<div class="bar bg-blue">
							<h3>Horse</h3>
						</div>
					</th>
					<th >
						<div class="bar bg-brown">
							<h3>Age</h3>
						</div> 
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Gender</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Sire</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Dam</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Owner</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>EQUIPMENT</h3>
						</div>
					</th>
					<th class="history edit view delete" colspan="3">&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(horse, i) in horses" :key="i">
					<td class="name"><Horse :horse="horse"/></td>
					<td class="age"><Age :year="horse.age_year"/></td>
					<td class="gender">{{ genders[horse.gender_id] ? genders[horse.gender_id].gender : '' }}</td>
					<td class="sire">{{ horse.sire }}</td>
					<td class="dam">{{ horse.dam }}</td>
					<td class="owner">{{ horse.owner }}</td>
					<td class="equipment">{{ parseEquipment(horse.equipment) }}</td>
					<td class="icon history">
						<button class="button-transparent" @click="$emit('history', horse)">
							<i class="ss-clock ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', horse)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', horse)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="horses.length === 0">
					<td colspan="7">No Horses found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Horse from '../Common/Horse.vue'
import Age from '../Common/Age.vue'

export default {
	props: ['horses'],
	components: {
		Horse,
		Age
	},
	computed: {
		genders() {
			return this.mapArrayById(this.$store.getters['gender/list'], 'id')
		},
		equipment() {
			return this.mapArrayById(this.$store.getters['equipment/list'], 'id')
		}
	},
	methods: {
		parseEquipment(ids) {
			if(ids && ids.length > 0 && Object.keys(this.equipment).length) {
				return ids.map(id => {
					return this.equipment[id].name
				}).join(', ')
			} else {
				return ''
			}
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Horses/List.vue